module.exports = __webpack_public_path__ + "img/sol_isol_pain2.4a25128b.png";